/*
|--------------------------------------------------------------------------
| Analytics: Pingdom
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.pingdom = {

	/**
	 * Initialize
	 */
	"init": function(){
		var commonJS 		= __gh__webApp.common;
			pingdomIDCheck	= commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.pingdom.id");
		if(!pingdomIDCheck){console.log("Pingdom ID is not set.");return;}
		var pingdomID		= __gh__coreData["3rdPartyData"].analytics.pingdom.id;
		// Add variables to head section
		__gh__webApp.common.loadScript({
			"text"			: "var _prum = [['id','"+pingdomID+"'],['mark', 'firstbyte', (new Date()).getTime()]];"
		});
		this.loadLibrary();
	},


	/**
	 * Load parse.ly library
	 */
	 "loadLibrary":function() {
		(function() {
		var s = document.getElementsByTagName('script')[0]
		, p = document.createElement('script');
		p.async = 'async';
		p.src = '//rum-static.pingdom.net/prum.min.js';
		s.parentNode.insertBefore(p, s);
		})();
	}
};